import React from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@material-ui/core";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { SimpleLoading } from "../../pures";
import cellDetailSignatureRequest from "./cellDetailSignatureRequest";
import cellDetailAditionalServices from "./cellDetailAditionalService";
import SignatureRequestDetailView from "../../views/signature-request-detail/signature-request-detail.view";
import "./signature-request-panel.pure.css";

const SignRequestCellHeader = (props) => {
  const stylesSpanCellHeader = {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    color: "#123513",
    fontSize: "14px",
    fontFamily: "Quicksand, sans-serif",
  };
  const stylesIconCellHeader = {
    marginLeft: "4px",
  };

  let iconFilter = "k-i-arrows-swap";
  if (props.children !== false) {
    iconFilter =
      props.children[0].props.className === "k-icon k-i-sort-asc-sm"
        ? "k-i-sort-asc-sm"
        : "k-i-sort-desc-sm";
  }

  return (
    <span style={stylesSpanCellHeader} onClick={props.onClick}>
      {props.title}
      <i style={stylesIconCellHeader} className={`k-icon ${iconFilter}`}></i>
    </span>
  );
};

const SignatureRequestPanelGeneralHeaderStyle = (props) => {
  const gridColumnGeneralStyle = {
    fontSize: "14px",
    color: "#123513",
    display: "flex",
    alignItems: "center",
  };

  return <span style={gridColumnGeneralStyle}>{props.title}</span>;
};

/* === Custom componente cells Solicitud for td elements of the Grid === */
const SignRequestCellSolicilud = (props) => {
  let colorItem = "";

  if (props.dataItem.signRequestStatusId) {
    if (props.dataItem.signRequestStatusId === 2) {
      colorItem = "#005EA0";
    } else if (props.dataItem.signRequestStatusId === 4) {
      colorItem = "#899232";
    } else if (props.dataItem.signRequestStatusId === 3) {
      colorItem = "#E63B31";
    } else if (props.dataItem.signRequestStatusId === 5) {
      colorItem = "#FF922C";
    } else {
      colorItem = "#000000";
    }
  }

  const cellItemStyles = {
    color: "#2C353C",
    fontSize: "16px",
    fontWeight: 550,
    borderBottom: "50px",
    textTransform: "capitalize",
    fontFamily: "Quicksand ",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
  };

  return (
    <td style={cellItemStyles}>
      <i
        className="k-icon k-i-more-vertical"
        style={{ color: `${colorItem}`, height: "20px" }}
      ></i>
      {props.dataItem[props.field]}
    </td>
  );
};

/* === Custom componente for td elements of the Grid === */
const SignRequestCell = (props) => {
  const cellItemStyles = {
    color: "#4c4c4c",
    fontSize: "16px",
    fontWeight: 550,
    fontFamily: "Quicksand, sans-serif",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
  };
  return <td style={cellItemStyles}>{props.dataItem[props.field]}</td>;
};

const SignRequestCellDate = (props) => {
  const cellItemStyles = {
    color: "#4c4c4c",
    fontSize: "16px",
    fontWeight: 550,
    textTransform: "capitalize",
    fontFamily: "Quicksand, sans-serif",
  };
  return <td style={cellItemStyles}>{props.dataItem[props.field]}</td>;
};

const SignRequestCellStatus = (props) => {
  const { t } = useTranslation();
  let statusName = "";

  switch (Number(props.dataItem.signRequestStatusId)) {
    case 2:
      statusName = t("signatureRequestPanelPure2.statusNamePending");
      break;
    case 3:
      statusName = t("signatureRequestPanelPure2.statusNameReject");
      break;
    case 4:
      statusName = t("signatureRequestPanelPure2.statusNameSigned");
      break;
    case 5:
      statusName = t("signatureRequestPanelPure2.statusNameCanceled");
      break;
    default:
      console.log("No se encontro el status de la solicitud");
  }

  const cellItemStyles = {
    color: "#4c4c4c",
    fontSize: "16px",
    fontWeight: 550,
    fontFamily: "Quicksand, sans-serif",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
  };
  return <td style={cellItemStyles}>{statusName}</td>;
};

/* === Pure component Grid of SignatureRequestPanel === */
const SignatureRequestPanelPure = (props) => {
  const { t } = useTranslation();
  const longmatches = useMediaQuery("(max-width:634px)");
  
  const generalContainerBorderStyles = {
    paddingTop: "20px",
    borderTop: "1px solid #dedede",
    borderBottom: "1px solid #dedede",
  };
  const gridSignatureRequestPanelStyle = {
    minHeight: "470px",
    fontFamily: "Quicksand, sans-serif",
  };
  const gridColumnNoRecordsStyle = {
    color: "#828282",
    fontSize: "17px",
    fontWeight: 600,
  };

  let { signatureRequests, total, filter, group, skip, take, sort } = props;
  const resultData = {
    data: signatureRequests,
    total,
  };
  const otherProps = {
    filter: filter ? filter : undefined,
    group: group ? group : undefined,
    sort: sort ? sort : [],
    skip,
    take,
  };

  return (
    <div>
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <div style={generalContainerBorderStyles}>
          <Grid
            className="signature-table"
            style={gridSignatureRequestPanelStyle}
            data={resultData}
            {...otherProps}
            sortable={true}
            resizable={true}
            reorderable={true}
            pageable={props.showPagination}
            onDataStateChange={props.dataStateChange}
          >
            <GridColumn
              field="name"
              title={t("signatureRequestPanelPure2.request")}
              minResizableWidth="auto"
              sortable={false}
              cell={SignRequestCellSolicilud}
              headerCell={SignatureRequestPanelGeneralHeaderStyle}
              width="150px"
            />
            {!longmatches ?
            <GridColumn
              field="signRequestStatusId"
              title={t("signatureRequestPanelPure2.status")}
              sortable={false}
              cell={SignRequestCellStatus}
              headerCell={SignatureRequestPanelGeneralHeaderStyle}
              width="60em"
              minResizableWidth="auto"
            />
            : null
            }
            
            {!longmatches ?
            <GridColumn
              field="createdDate"
              title={t("signatureRequestPanelPure2.createdDate")}
              textTransform="capitalize"
              width="60em"
              cell={SignRequestCellDate}
              headerCell={SignRequestCellHeader}
              minResizableWidth="10px"
              />
              : null
            }
            <GridColumn
              field="expirationDate"
              title={t("signatureRequestPanelPure2.expirationDate")}
              textTransform="capitalize"
              width="60em"
              cell={SignRequestCellDate}
              headerCell={SignRequestCellHeader}
              minResizableWidth="10px"
            />
            
            
            {!longmatches ? 
            <GridColumn
              field="additional"
              title={t("signatureRequestPanelPure2.attributes")}
              width="100px"
              sortable={false}
              cell={cellDetailAditionalServices(
                props.tooltipStampingTime,
                props.tooltipConservationMessage
              )}
              headerCell={SignatureRequestPanelGeneralHeaderStyle}
              minResizableWidth="auto"
            />
              : null
            }
            <GridColumn
              field="actions"
              title={t("signatureRequestPanelPure2.actions")}
              className="eyes-btn-grid"
              minResizableWidth="100px"
              width="100px"
              sortable={false}
              cell={cellDetailSignatureRequest({
                selectedFilter: props.signRequestListId,
                buttonClasss: props.buttonClass,
                edit: props.edit,
                seeDetail: props.seeDetail,
                tracking: props.tracking,
                tooltipDetail: props.tooltipDetail,
                tooltipDelete: props.tooltipDelete,
                toggleDialogDeleteRequest: props.toggleDialogDeleteRequest,
                view: props.view,
                visibilityIcon: true,
                userMiFirmaId: props.userMiFirmaId,
                killMe: props.killMe,
                isHideTrash: props.isHideTrash,
              })}
              headerCell={SignatureRequestPanelGeneralHeaderStyle}
            />
            <GridNoRecords>
              <span style={gridColumnNoRecordsStyle}>
                {t("signatureRequestPanelPure2.notResults")}
              </span>
            </GridNoRecords>
            {props.signatureRequestInEdit && (
              <SignatureRequestDetailView
                {...props}
                dataItem={props.signatureRequestInEdit}
                edit={props.edit}
                onChangeSignatureRequest={props.onChangeSignatureRequest}
              />
            )}
          </Grid>
        </div>
      )}
    </div>
  );
};
export { SignatureRequestPanelPure as default };
